<template>
  <div class="row text-white">
    <detalle-item />
    <form-rendicion-item />
    <q-form @submit.prevent="rendir()">
      <div class="col-xs-12 q-px-none">
        <q-list separator dark>
          <!-- Información de la aplicación -->
          <q-expansion-item
            dense
            dense-toggle
            expand-separator
            label="INFORMACIÓN DE LA RENDICIÓN"
            class="text-bold"
            default-opened
          >
            <div class="row q-gutter-y-sm q-pb-sm">
              <div class="col-xs-6 text-white q-pr-xs">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Monto Desembolso
                  </q-card-section>
                  <q-card-section class="q-pa-xs text-red">
                    {{util.numberMoney(amounts.total_desembolso) }}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-6 text-white q-pl-xs">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Monto Rendido
                  </q-card-section>
                  <q-card-section class="q-pa-xs text-positive">
                    {{util.numberMoney(amounts.total_rendido)}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-6 text-white q-pr-xs">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Monto favor del solicitante
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{util.numberMoney(amounts.favor_solicitante)}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-6 text-white q-pl-xs">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Monto favor de la empresa
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{util.numberMoney(amounts.favor_empresa)}}
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </q-expansion-item>
          <!-- Items para rendir -->
          <q-expansion-item
            dense
            dense-toggle
            expand-separator
            label="ÍTEMS PARA RENDIR"
            class="text-bold"
            default-opened
          >
            <div class="row" v-if="items.length == 0">
              <div class="col-xs-12 text-right q-pa-sm">
                <q-btn
                  class="bg-pragma"
                  round
                  icon="add"
                  @click="addItemRendicion()"
                ></q-btn>
              </div>
              <div class="col-xs-12 text-center text-grey q-pa-sm">
                <q-icon name="sentiment_very_satisfied"></q-icon>
                Ya se rindieron todos los ítems
              </div>
            </div>
            <div class="row" v-if="items.length > 0">
              <div class="col-xs-12 text-right q-pa-sm">
                <q-btn
                  class="bg-pragma"
                  round
                  icon="add"
                  @click="addItemRendicion()"
                ></q-btn>
              </div>
              <div class="col-xs-12 q-px-sm">
                <q-list bordered separator dark>

                  <q-slide-item
                    @left="opt => onLeft(item, index, opt)"
                    @right="opt => onRight(index, opt)"
                    @click="verDetalleItem(item)"
                    right-color="negative"
                    left-color="positive"
                    v-for="(item, index) in items"
                    :key="item.detalle"
                    :class="index%2 == 0 ? 'bg-grey-9' : 'bg-grey-8'"
                  >
                    <template v-slot:left>
                      <q-icon name="check" />
                    </template>
                    <template v-slot:right>
                      <q-icon name="delete" />
                    </template>

                    <q-item class="text-uppercase">
                      <q-item-section>
                        <q-item-label>{{item.detalle}}</q-item-label>
                        <q-item-label caption>Cant.: {{~~item.cantidad}}</q-item-label>
                      </q-item-section>

                      <q-item-section side top>
                        <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                        <q-item-label class="text-right text-caption q-pt-lg text-bold">Subtotal: {{util.numberMoney(item.costo * item.cantidad)}}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-slide-item>

                </q-list>
              </div>
            </div>
          </q-expansion-item>
          <!-- Items rendidos -->
          <q-expansion-item
            dense
            dense-toggle
            expand-separator
            label="ÍTEMS RENDIDOS"
            class="text-bold"
            default-opened
          >
            <div class="row" v-if="items_rendidos.length > 0">
              <div class="col-xs-12 q-px-sm">
                <q-list bordered separator dark>

                  <q-slide-item
                    @right="opt => onRightRendido(item, index, opt)"
                    @click="verDetalleItem(item)"
                    right-color="negative"
                    v-for="(item, index) in items_rendidos"
                    :key="item.detalle"
                    :class="index%2 == 0 ? 'bg-grey-9' : 'bg-grey-8'"
                  >
                    <template v-slot:right>
                      <q-icon name="delete" />
                    </template>

                    <q-item class="text-uppercase">
                      <q-item-section>
                        <q-item-label>{{item.detalle}}</q-item-label>
                        <q-item-label caption>Cant.: {{~~item.cantidad}}</q-item-label>
                      </q-item-section>

                      <q-item-section side top>
                        <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                        <q-item-label class="text-right text-caption q-pt-lg text-bold">Subtotal: {{util.numberMoney(item.costo * item.cantidad)}}</q-item-label>
                      </q-item-section>
                    </q-item>
                  </q-slide-item>

                </q-list>
              </div>
            </div>
            <div class="row" v-if="items_rendidos.length == 0">
              <div class="col-xs-12 text-center text-grey q-pa-sm">
                <q-icon name="sentiment_very_dissatisfied"></q-icon>
                No hay ítems rendidos aún
              </div>
            </div>
          </q-expansion-item>
        </q-list>
      </div>
    </q-form>
  </div>
</template>

<script>
import { inject, ref } from 'vue'
import axios from 'axios'
import util from '../../../plugins/util'
import DetalleItem from '../../solicitud/dialogs/DetalleItem.vue'
import FormRendicionItem from './FormRendirItem.vue'

export default {
  components: {
    DetalleItem,
    FormRendicionItem
  },
  props: ['items', 'items_rendidos', 'solicitud', 'amounts'],
  setup (props) {
    // Variables
    const bus = inject('bus')
    const loading = ref(false)

    // Métodos y funciones
    const verDetalleItem = (item) => {
      item.precio_unitario = item.costo
      item.sub_total = item.subtotal
      bus.emit('openDialogDetalleItem', item)
    }

    const onLeft = (item, index, {reset}) => {
      item.solicitud_id = props.solicitud.id
      bus.emit('openDialogFormRendirItem', item)
      reset()
    }

    const onRight = (index, {reset}) => {
      reset()
    }

    const onRightRendido = async (item, index, {reset}) => {
      try {
        await axios.get(`/solicitudes/item/rendidos/eliminar?doc=${item.id}`)
        bus.emit('refreshRendicion')
      } catch (error) {
        console.log(error)
      }
      reset()
    }

    const addItemRendicion = () => {
      let data = {}
      data.solicitud_id = props.solicitud.id
      bus.emit('openDialogFormRendirItem', data)
    }

    // Creación del componente

    // Template
    return {
      verDetalleItem,
      util,
      onLeft,
      onRight,
      loading,
      onRightRendido,
      addItemRendicion
    }
  }
}
</script>

<style>

</style>